import { Navigate, useParams } from 'react-router-dom';

import useSystemOptionsStore from 'src/stores/systemOptionsStore';

/** Redirect old path-based competition URLs to query-param insights. */
export default function InsightsCompetitionLegacyRedirect() {
  const { competition } = useParams<{ competition: string }>();
  const { activeEditionId, editionsById } = useSystemOptionsStore(s => s);

  const year =
    activeEditionId && editionsById?.[activeEditionId]
      ? String(editionsById[activeEditionId].year)
      : undefined;

  const next = new URLSearchParams();
  if (year) next.set('year', year);
  if (competition) next.set('competition', competition);

  const qs = next.toString();
  return <Navigate to={qs ? `/dashboard/insights?${qs}` : '/dashboard/insights'} replace />;
}
